import PropTypes from 'prop-types';

import { Flex, IconWarningOutline } from '@zillow/constellation';
import { Heading, Modal, Paragraph } from '@zillow/constellation-10';

const propTypes = { close: PropTypes.func.isRequired };
const defaultProps = {};

const SecurityDepositUpdateFailureModal = ({ close }) => {
  const body = (
    <>
      <Flex display="flex" alignItems="center" flexDirection="column" marginBottom="sm">
        <IconWarningOutline fontColor="brand" size="lg" marginY="xs" />
        <Heading level={4}>A problem occurred</Heading>
      </Flex>
      <Paragraph>
        We are not able to update the security deposit currently. Please try again later or contact customer support.
      </Paragraph>
    </>
  );

  return (
    <Modal
      open={true}
      onOpenChange={(open) => !open && close()}
      header={<Heading level={2}>A problem occurred</Heading>}
      body={<div data-testid="SecurityDepositUpdateFailureModal">{body}</div>}
      useDismissProps={{
        escapeKey: true,
        outsidePress: false,
      }}
      size={{ base: 'fullScreen', md: 'sm' }}
    />
  );
};

SecurityDepositUpdateFailureModal.propTypes = propTypes;
SecurityDepositUpdateFailureModal.defaultProps = defaultProps;

export default SecurityDepositUpdateFailureModal;
